import { addProps, SimplePropsAdder } from 'ad-hok'
import { useTranslation } from 'react-i18next'
import { TFunction } from 'i18next'

type AddTranslationHelpersType = SimplePropsAdder<{
  t: TFunction
}>

export const addTranslationHelpers: AddTranslationHelpersType = addProps(
  () => ({
    t: useTranslation().t,
  })
)
